// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"CustomNumberInput_buttonWrapper__101xF"};